import React from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';

import PageHeader from '@/components/PageHeader';
import { BreadCrumbType } from '@/typings/common';
import { convertAliasToPathQuery, convertSlugToPath } from '@/utils/common';
import { useTypedSelector } from '@/store/store';
import { selectCategoryByAlias } from '@/store/reducers/pages/catalog/catalog';
import { colors } from '@/constants/theme';

type Props = {
  count?: number;
  showPagesAmount?: boolean;
};

function Top({ showPagesAmount, count }: Props) {
  const router = useRouter();
  const alias = convertAliasToPathQuery(convertSlugToPath(router.query.alias));

  const currentCategory = useTypedSelector((state) =>
    selectCategoryByAlias(state, alias)
  );
  const BreadCrumbs: BreadCrumbType[] = [];

  BreadCrumbs.push({
    label: currentCategory.data?.name,
    url: `catalog/${alias}`,
  });

  if (!!currentCategory.data?.parents.length) {
    currentCategory.data.parents.forEach((data) => {
      BreadCrumbs.push({
        label: data.name,
        url: data.url,
      });
    });
  }

  return (
    <Component>
      <PageHeader breadCrumbs={BreadCrumbs.reverse()} />
      <Content>
        {currentCategory.data?.name ? (
          <>
            <Title>{currentCategory.data.name}</Title>
            {showPagesAmount ? <Count>{count}</Count> : null}
          </>
        ) : null}
      </Content>
    </Component>
  );
}

export default Top;

const Component = styled.div``;
const Content = styled.div`
  display: flex;
  align-items: center;
`;
const Title = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
`;

const Count = styled.span`
  margin-left: 12px;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: ${colors.gray300};
`;
